export function extraServiceAmountIsValid(serviceAmount: number | string): boolean {
    const amount = typeof serviceAmount === 'string' ? Number(serviceAmount) : serviceAmount;
    return !!amount && amount < 11 && amount > 0 && !!amount.toString().match(/^[0-9\b]+$/);
}
